// eslint-disable-next-line no-unused-vars
import { Box } from '@mui/material';
import { Card, CardMedia, CardContent } from '../common/Card/index.js';
import { PLACEHOLDER_IMAGES } from '../../constants/images';
import { EXTERNAL_LINKS } from '../../constants/links';

const ParadiseCloudSection = () => {
  return (
    <Box sx={{ width: { xs: '100%', md: '66.66%' }, display: 'flex' }}>
      <Card
        height={400}
        href={EXTERNAL_LINKS.paradiseCloud}
        sx={{ width: '100%', height: '400px' }}
      >
        <CardMedia image={PLACEHOLDER_IMAGES.features.paradiseCloud} />
        <CardContent 
          title="PARADISE CLOUD"
          subtitle="Your gateway to the Paradise ecosystem"
          isSpecialTitle
        />
      </Card>
    </Box>
  );
};

export default ParadiseCloudSection;
